import { useSelector } from 'react-redux';
import { useIsPanelOpenPreference } from 'app/hooks';

const useIsPanelOpen = () => {
  const isPanelOpenPreference = useIsPanelOpenPreference();
  const renderGatewayView = useSelector(
    (state) => state.gallery.renderGatewayView
  );

  return isPanelOpenPreference === 'open' && !renderGatewayView;
};

export default useIsPanelOpen;
